import styleMerge from 'classnames'
import { Link } from 'react-router-dom'
import sanitizeHTML from 'sanitize-html'

import { Loader } from 'core-components/library/loader'

import { IButtonProps } from './models/IButtonProps'

import styles from './Button.module.scss'

export const Button = ({
  children,
  className,
  icon,
  iconPosition = 'start',
  iconButton,
  title,
  onClick,
  href,
  target,
  rel,
  to,
  id,
  type = 'button',
  variant = 'contained',
  color = 'primary',
  size = 'sm',
  margin = 'none',
  disabled = false,
  active = false,
  block = false,
  loading = false,
  form,
  role,
  ariaSelected,
  ariaControls,
  __testId,
}: IButtonProps) => {
  const commonProps = {
    form,
    title,
    onClick,
    role,
    'aria-selected': ariaSelected,
    'aria-controls': ariaControls,
    className: styleMerge(
      styles[variant],
      {
        [styles[`${variant}--${color}`]]: color,
        [styles[`margin-${margin}`]]: margin,
        [styles.active]: active,
        [styles.disabled]: disabled,
        [styles.block]: block,
        [styles['icon-button']]: iconButton,
        [styles[`size-md`]]: size === 'md',
        [styles['loading']]: loading,
      },
      className || ''
    ),
  }

  const content = (
    <span className={styles.inner}>
      {iconButton ? (
        <i className={styleMerge(styles.icon, styles['icon-button__icon'], iconButton)} />
      ) : (
        <>
          {icon && <i className={styleMerge(styles.icon, styles[`icon-${iconPosition}`], icon)} />}
          <span className={styles.caption}>{children}</span>
        </>
      )}
      {loading ? <Loader className={styles.loader} dimension={{ width: 22, height: 22 }} /> : <></>}
    </span>
  )

  if (href) {
    return (
      <a {...commonProps} href={sanitizeHTML(href)} target={target} rel={rel} id={id}>
        {content}
      </a>
    )
  }

  if (to) {
    return (
      <Link {...commonProps} to={to} target={target} rel={rel} id={id}>
        {content}
      </Link>
    )
  }

  return (
    <button
      {...commonProps}
      disabled={disabled || loading}
      type={type}
      id={id}
      data-testid={__testId || 'buttonRoot'}
    >
      {content}
    </button>
  )
}
